import { render, staticRenderFns } from "./DeLeft2RightDragBar.vue?vue&type=template&id=56d0f712&scoped=true"
import script from "./DeLeft2RightDragBar.vue?vue&type=script&lang=js"
export * from "./DeLeft2RightDragBar.vue?vue&type=script&lang=js"
import style0 from "./DeLeft2RightDragBar.vue?vue&type=style&index=0&id=56d0f712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0f712",
  null
  
)

export default component.exports